export default __webpack_public_path__ + "ubisoft-playtest-programming-black.webp";